import { render } from "./house.vue?vue&type=template&id=5842b63c&scoped=true"
import script from "./house.vue?vue&type=script&lang=js"
export * from "./house.vue?vue&type=script&lang=js"

import "./house.vue?vue&type=style&index=0&id=5842b63c&lang=scss&scoped=true"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5842b63c"]])

export default __exports__